import { render, staticRenderFns } from "./ShopNav.vue?vue&type=template&id=627d580e&scoped=true&"
import script from "./ShopNav.vue?vue&type=script&lang=js&"
export * from "./ShopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627d580e",
  null
  
)

export default component.exports